import { render, staticRenderFns } from "./referral-code.vue?vue&type=template&id=78b0fd6e&scoped=true"
import script from "./referral-code.vue?vue&type=script&lang=js"
export * from "./referral-code.vue?vue&type=script&lang=js"
import style0 from "./referral-code.vue?vue&type=style&index=0&id=78b0fd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b0fd6e",
  null
  
)

export default component.exports